import { snakeCase } from 'lodash';

export default function mapEventNameToActionType(name) {
  return snakeCase(`Handle${name}`).toUpperCase();
}




// WEBPACK FOOTER //
// ./src/framework/events/map-event-name-to-action-type.js